<template>
  <div id="v-widget">
    <v-card :flat="flat">
      <v-card-text v-if="search">
        <slot name="widget-search" />
      </v-card-text>
      <v-divider v-if="search" />
      <v-flex :class="classWidget">
        <v-card-text class="pa-0">
          <slot name="widget-content" />
        </v-card-text>
      </v-flex>
      <v-divider v-if="paginate" />
      <v-flex
        v-if="paginate"
        :class="classWidget"
      >
        <v-card-text class="text-xs-center">
          <slot name="widget-paginate" />
        </v-card-text>
      </v-flex>
      <v-flex
        v-if="actions"
        :class="classWidget"
      >
        <v-card-actions>
          <slot name="widget-actions" />
        </v-card-actions>
      </v-flex>
    </v-card>
  </div>
</template>

<script>
export default {
  name: 'AppWidget',
  props: {
    header: {
      type: Boolean,
      default: false
    },
    search: {
      type: Boolean,
      default: false
    },
    flat: {
      type: Boolean,
      default: false
    },
    paginate: {
      type: Boolean,
      default: false
    },
    actions: {
      type: Boolean,
      default: false
    },
    classWidget: {
      type: String,
      default: ''
    }
  },
  data () {
    return {}
  },
  computed: {}
}
</script>
